import React from 'react';

import MergeFulfillments from '@components/shared/fulfillments/MergeFulfillments';
import { useMerchant } from '@contexts/admin/MerchantContext';
import ListPageHeader from '@shared/ListPageHeader';
import { useTranslation } from 'react-i18next';

import { fulfillmentService } from '@services/admin/fulfillmentService';

const AdminFulfillmentMerge = () => {
  const { t } = useTranslation();
  const { currentMerchant } = useMerchant();

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['fulfillments', 'fulfillments.merge']}
      />
      <MergeFulfillments
        fulfillmentService={fulfillmentService}
        role="admin"
        merchantId={currentMerchant?.id}
        hideBackButton
      />
    </div>
  );
};

export default AdminFulfillmentMerge;
